const FB_PIXEL_ID = '983002450384116';

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: (...args: any[]) => void;
    __fbPixelInitialized?: boolean;
  }
}

function loadPixelScript() {
  if (typeof window === 'undefined') return;
  if (window.fbq) return;

  const w = window as Window;
  const fbq = function (...args: any[]) {
    (fbq as any).callMethod ? (fbq as any).callMethod.apply(fbq, args) : (fbq as any).queue.push(args);
  };
  (fbq as any).queue = [];
  (fbq as any).loaded = true;
  (fbq as any).version = '2.0';

  w.fbq = fbq;
  w._fbq = fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const first = document.getElementsByTagName('script')[0];
  if (first?.parentNode) {
    first.parentNode.insertBefore(script, first);
  } else {
    document.head.appendChild(script);
  }
}

export function initFacebookPixel() {
  if (typeof window === 'undefined') return;
  if (!window.fbq) loadPixelScript();
  if (!window.__fbPixelInitialized && window.fbq) {
    window.fbq('init', FB_PIXEL_ID);
    window.__fbPixelInitialized = true;
  }
}

export function trackFacebookPageView() {
  if (typeof window === 'undefined') return;
  if (!window.fbq) return;
  window.fbq('track', 'PageView');
}
